<template>
  <div class="Location-container">
    <address-location
      v-if="page === 'addressLocation'"
      :switch="this.switch"
      :nearBy="nearBy"
      :updateNearBy="updateNearBy"
      :location="getCityInfo"
    ></address-location>
    <city-selection
      v-if="page === 'citySelection'"
      :switch="this.switch"
    ></city-selection>
    <div id="container"></div>
  </div>
</template>

<script>
import AddressLocation from './AddressLocation/AddressLocation';
import CitySelection from './CitySelection/CitySelection';
import store from '../../../stores';
// 已迁移至百度地图
import bmapService from '@stores/location/bmap';
export default _extend({
  name: 'Home',
  data() {
    return {
      page: 'addressLocation',
      map: null,
      resMap: null,
      nearBy: [],
      timeStamp: 0,
      amapInstance: bmapService, // 保持变量名兼容
      poiis: []
    };
  },
  components: {
    AddressLocation,
    CitySelection
  },
  methods: {
    switch(val) {
      this.page = val;
    },
    sleep(delay) {
      let start = new Date().getTime();
      while (new Date().getTime() - start < delay) {
        continue;
      }
    },
    // 获取当前位置信息
    async getCityInfo() {
      this.amapInstance.resetPlacesearchCity();
      this.nearBy = [];
      this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_POSITION_STATUS, false);
      const { currentLocation } = this.amapInstance;
      console.log('getCityInfo  currentLocation:', this.amapInstance);
      this.$store.commit(store.VX_TYPES.FORM.UPDATE_ADDRESS, {
        province: currentLocation.addressComponent.province,
        city: currentLocation.addressComponent.city,
        district: currentLocation.addressComponent.district
      });
      let address = await this.analyzeAddress(currentLocation);
      console.log('getCityInfo  address:', address);
      this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_POSITION_STATUS, true);
      this.$store.commit(store.VX_TYPES.LOCATION.UPDATE_ADDRESS_INFO, address);
      this.nearBy = address.nearBy;
    },
    // 定位地址解析
    async analyzeAddress(res) {
      const { addressComponent, formattedAddress } = res;
      window.console.log('map----address---->', addressComponent);
      const address =
        addressComponent.province +
        addressComponent.city +
        addressComponent.district;
      const name = formattedAddress.substring(address.length);
      const nearByAddress = await this.getNearby();
      console.log('analyzeAddress  nearByAddress:', nearByAddress);
      return {
        province: addressComponent.province,
        city: addressComponent.city,
        district: addressComponent.district,
        current: { address, name },
        nearBy: nearByAddress
      };
    },
    getNearby() {
      return new Promise(resolve => {
        const nearByAddress = [];

        this.amapInstance.searchNearby((status, result) => {
          if (status === 'complete') {
            this.pois = result.poiList.pois;
          } else {
            this.pois = [];
          }
          this.pois.forEach(item => {
            let obj = {
              name: '',
              address: ''
            };
            obj.name = item.name;
            obj.address = item.address || '';
            nearByAddress.push(obj);
          });
          resolve(nearByAddress);
        });
      });
    },

    // 更新附近地址
    updateNearBy(list) {
      this.nearBy = list;
    }
  },
  couputed: {
    getCity() {
      let city = this.$store.state.location.selectedCity;
      if (this.$store.state.location.city !== city) {
        this.nearBy = [];
      }
      if (city.length < 4) {
        return city;
      } else {
        return city.substring(0, 3) + '...';
      }
    }
  },
  created() {
    window.title = '地图';
  },
  async mounted() {
    this.getCityInfo();
  }
});
</script>

<style lang="scss">
@import './Location.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/Location/Location.vue